module.exports = __webpack_public_path__ + "img/Karla.5c9eff94.jpeg";